"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _markdownDiv = _interopRequireDefault(require("../../markdown-div/markdown-div"));

var _growingEntry = _interopRequireDefault(require("../../growing-entry/growing-entry"));

var _markdownOverlayEditorStyle = require("./markdown-overlay-editor-style");

var _utils = require("../../common/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MarkdownOverlayEditor = function MarkdownOverlayEditor(p) {
  var markdown = p.markdown,
      onChange = p.onChange,
      onKeyDown = p.onKeyDown,
      forceEditMode = p.forceEditMode,
      createNode = p.createNode,
      targetRect = p.targetRect,
      readonly = p.readonly,
      onFinishEditing = p.onFinishEditing;

  var _React$useState = React.useState(markdown === "" || forceEditMode),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editMode = _React$useState2[0],
      setEditMode = _React$useState2[1];

  var onEditClick = React.useCallback(function () {
    setEditMode(function (e) {
      return !e;
    });
  }, []);
  var addLeftPad = markdown ? "ml-6" : "";

  if (editMode) {
    return /*#__PURE__*/React.createElement(_markdownOverlayEditorStyle.MarkdownOverlayEditorStyle, {
      targetRect: targetRect
    }, /*#__PURE__*/React.createElement(_growingEntry.default, {
      autoFocus: true,
      onKeyDown: onKeyDown,
      value: markdown,
      onChange: onChange
    }), /*#__PURE__*/React.createElement("div", {
      className: "edit-icon checkmark-hover ".concat(addLeftPad),
      onClick: function onClick() {
        onEditClick();
        onFinishEditing(undefined, [0, 1]);
      }
    }, /*#__PURE__*/React.createElement(_utils.Checkmark, null)));
  }

  return /*#__PURE__*/React.createElement(_markdownOverlayEditorStyle.MarkdownOverlayEditorStyle, {
    targetRect: targetRect
  }, /*#__PURE__*/React.createElement(_markdownDiv.default, {
    contents: markdown,
    createNode: createNode
  }), !readonly && /*#__PURE__*/React.createElement("div", {
    className: "edit-icon edit-hover ".concat(addLeftPad),
    onClick: onEditClick
  }, /*#__PURE__*/React.createElement(_utils.EditPencil, null)), /*#__PURE__*/React.createElement("textarea", {
    className: "md-edit-textarea",
    autoFocus: true,
    onKeyDown: onKeyDown
  }));
};

var _default = MarkdownOverlayEditor;
exports.default = _default;